module.exports = __webpack_public_path__ + "static/assets/90d8a0dd4050807a3bd165e2a5ee9e82.svg";